import * as CategoryTypes from './categoriesTypes';

const initialState = {
    items: [],
    initialized: false,

    error: undefined,
};

export const CategoriesReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case CategoryTypes.SET_INITIALIZED:
            return {
                ...state,
                initialized: action.payload.initialized,
            };
        case CategoryTypes.SET_ITEMS:
            return {
                ...state,
                items: action.payload.items,
            };
        case CategoryTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload.error,
            };
        default:
            return state;
    }
};
